import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

// request
import { CreateLog } from '../models/request/create-log.model';

import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LogsService {
  readonly #urlApiManagement = environment.urlApiManagement;

  readonly #http = inject(HttpClient);

  createLog(params: CreateLog): Observable<any> {
    const url = `${this.#urlApiManagement}/api/v1/users/creates-logs`;
    return this.#http.post<any>(url, params);
  }
}
